import { Theme } from '@app/theme';
import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme: Theme) => ({
  address: {
    ...theme.fonts.label,
    fontStyle: 'normal',
    padding: theme.marginBase,
    whiteSpace: 'pre-line',
    backgroundColor: theme.colors.grayBackground,
    borderRadius: theme.borderRadius.std,
  },
}));

export const Address = ({
  className,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) => {
  const classes = useStyles();
  return (
    <address {...props} className={classNames(classes.address, className)} />
  );
};
